import React, { InputHTMLAttributes } from 'react'

import cn from 'classnames'

import Icon from '../Icon/Icon'
import styles from './DynamicInput.module.scss'

interface DynamicInputProps extends InputHTMLAttributes<HTMLInputElement> {
  inputValue: string

  showIcon?: boolean
  iconName?: string

  className?: string
}

const DynamicInput = ({
  inputValue,
  showIcon = true,
  iconName = 'bigWhiteStar',
  className,
  ...props
}: DynamicInputProps) => {
  return (
    <div className={cn(styles.amount, className)}>
      <input
        className={styles.amount_input}
        value={inputValue}
        style={{ width: `${Math.max(inputValue.length, 1)}ch` }}
        {...props}
      />
      {showIcon && <Icon name={iconName} />}
    </div>
  )
}

export default DynamicInput
